import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { SplideSlide } from '@splidejs/react-splide';
import classNames from 'classnames';
export default function DCarouselSlide(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx(SplideSlide, Object.assign({ className: classNames('d-carousel-slide', className) }, props)));
}
//# sourceMappingURL=DCarouselSlide.js.map